import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';

Vue.component("classification-system-items-treeview", {
	props: ["classificationSystemId","classificationHierarchies"],
	data() {
		return {
			isLoading: false,
			classificationSystemItems: null,
		};
	},
	mounted() {
		this.load();
	},
	methods: {
		load() {
			const self = this;

			self.isLoading = true;
			self.$services.classificationHierarchies.getTreeview({
				classificationSystemId: self.classificationSystemId,
				classificationHierarchyIds: self.classificationHierarchies,
				language: window.currentLanguage
			}).then((data) => {
				console.log(data)
				self.classificationSystemItems = new Tree(data);
				self.isLoading = false;
			});
		}
	},
	template: `      	
		<div>
			<template v-if="isLoading"><loading></loading></template>
			<template v-else>
				<div v-if="classificationSystemItems != null">
					<vue-tree-list
						:model="classificationSystemItems"
						v-bind:default-expanded="false">
						<template v-slot:leafNameDisplay="props">
							<div class="entity-row" :id="'classification_' + props.model.id" v-if="props.model.children != null && props.model.children.length > 0">
								<div class="entity-row-display-name" v-html="props.model.name"></div>							
							</div>						
						</template>
						<template v-slot:treeNodeIcon="props">
							<span class="icon">							
								<i v-if="props.model.children && props.model.children.length > 0" class="fa fa-sitemap"></i>					
								<i v-else class="fa fa-fw"></i>
							</span>
						</template>
					</vue-tree-list>
				</div>
			</template>
		</div>
	`
});
